import { useLocation } from 'react-router-dom';

export default function (init: 'search' | 'hash' = 'search') {
  return new URLSearchParams(useLocation()[init]);
}
